/**
 * Support module for Primeng Theme.
 * This file provides shared implementation details for its surrounding feature or platform area.
 */
import { definePreset } from '@primeuix/themes';
import Aura from '@primeuix/themes/aura';

export const retailPrimePreset = definePreset(Aura, {
  semantic: {
    primary: {
      50: '#eef6ff',
      100: '#d9e9ff',
      200: '#b8d8ff',
      300: '#8ebfff',
      400: '#5f9ae7',
      500: '#3e79cf',
      600: '#1f62b5',
      700: '#004b93',
      800: '#003a72',
      900: '#001129'
    },
    colorScheme: {
      light: {
        surface: {
          0: '#ffffff',
          50: '#f5f5f5',
          100: '#efefef',
          200: '#e0e0e0',
          300: '#d0d0d0',
          400: '#b0b0b0',
          500: '#888888',
          600: '#666666',
          700: '#333333',
          800: '#1a1a1a',
          900: '#0d0d0d'
        },
        primary: {
          color: '{primary.700}',
          contrastColor: '#ffffff',
          hoverColor: '{primary.800}',
          activeColor: '{primary.900}'
        },
        highlight: {
          background: '{primary.50}',
          focusBackground: '{primary.100}',
          color: '{primary.700}',
          focusColor: '{primary.800}'
        }
      },
      dark: {
        surface: {
          0: '#07111d',
          50: '#0d1827',
          100: '#132235',
          200: '#18293d',
          300: '#20364f',
          400: '#2c4663',
          500: '#56708c',
          600: '#89a0b7',
          700: '#b6c7d8',
          800: '#dce7f2',
          900: '#f2f7fc'
        },
        primary: {
          color: '{primary.400}',
          contrastColor: '#07111d',
          hoverColor: '{primary.300}',
          activeColor: '{primary.200}'
        },
        highlight: {
          background: 'color-mix(in srgb, {primary.400} 18%, {surface.100})',
          focusBackground: 'color-mix(in srgb, {primary.400} 28%, {surface.200})',
          color: '{primary.400}',
          focusColor: '{primary.300}'
        }
      }
    }
  }
});
